import { Formik } from 'formik';
import React from 'react';

import cx from '../../utils/classnames';

import type { FormikConfig, FormikProps, FormikValues } from 'formik';
export type Props<T extends FormikValues = FormikValues> = FormikConfig<T> & {
  /** Custom style for wrapper */
  className?: string;
  /** use either children render-prop or ordinary ReactNode */
  children?: ((props: FormikProps<T>) => React.ReactNode) | React.ReactNode;
  hasValidateOnBlur?: boolean;
};

export function Form<T extends FormikValues = FormikValues>(props: Props<T>) {
  const { className, children, hasValidateOnBlur = false, ...formikConfig } = props;

  return (
    <div className={cx(className)}>
      <Formik<T> validateOnBlur={hasValidateOnBlur} {...formikConfig}>
        {children}
      </Formik>
    </div>
  );
}

export default Form;
